import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from '../../../common/services/appServiceManager';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Configuration } from 'config/config';
import { Asset } from "app/shared/Domains/asset";
import { HttpClient } from '@angular/common/http';
import { CalendarModule } from 'primeng/calendar';
import { IBranch } from "app/shared/Domains/branch";
import { AppUtils } from 'common/services/app.util';
import { NgxSpinnerService } from "ngx-spinner";
import { LanguageService } from 'app/LanguageService/Language.Service';
import { DatePipe } from "@angular/common";
import { WebcamImage, WebcamInitError, WebcamUtil } from "ngx-webcam";
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AuthService } from "./../../../common/services/auth.service";
import { ICompany } from 'app/shared/Domains/company';





@Component({
  selector: "app-asset-details",
  templateUrl: "./asset-details.component.html",
  styleUrls: ["./asset-details.component.css"]
})
export class AssetDetailsComponent implements OnInit {
  assetForm: FormGroup;
  maintenanceForm: FormGroup;
  asset: Asset = new Asset();
  categories: any = []; // Example categories (you'll fetch them dynamically)
  currentUser: string;
  companySessionStorage: any;
  branchSessionStorage: any;
  branch: IBranch;
  addProfileImage: any;
  dialogVisibility: boolean;
  uploadProfile: any;
  invoiceData: any;
  uploadProfilePath: any;
  date: any;
  company: ICompany;
  public webcamImage: WebcamImage = null;
  assetID: any;
  MaintenanceTabActive: boolean;
  index: any = '';
  statusOptions: { label: string; value: string; }[];
  maintenanceLogs: any = {
    lastMaintenanceDate: null,
    nextMaintenanceDate: null,
    maintenanceDate: null,
    maintainedBy: '',
    maintenanceReason:'',
    notes: '',
    cost: null,
    status: '',
  };
  createMaintenanceLogs: any = {
    lastMaintenanceDate: null,
    nextMaintenanceDate: null,
    maintenanceDate: null,
    maintainedBy: '',
    maintenanceReason:'',
    notes: '',
    cost: null,
    status: '',
  };
  displayCompleteDialog: boolean = false;
  displayMaintenaceDialog: boolean = false;
  currentDate: Date = new Date();
  loading: boolean = false;
  selectedLogId: string;
  reports: any;
  constructor(
    private fb: FormBuilder,
    private LanguageService: LanguageService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    public config: Configuration,
    private _http: HttpClient,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private loader: NgxSpinnerService,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Asset Detail' },
      { label: 'Asset Detail', routerLink: ['/asset-detail'] }
    ]);
  }

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AssetDetailsComponent", label);
  }
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      if (this.assetID === undefined) {
        this.assetID = params["id"];
      } else if (this.assetID !== params["id"]) {
        this.assetID = params["id"];
        this.getAssetById();
      }
    });
    // Initialize the form group with controls and validators
    this.assetForm = this.fb.group({
      name: ['', Validators.required],
      profile: [''],
      category: ['', Validators.required],
      purchaseDate: ['', Validators.required],
      status: ['', Validators.required],
      cost: ['', [Validators.required, Validators.min(0)]],
      serialNumber: ['', Validators.required],
      description: [''],
      warrantyExpiry: [''],
    });
    this.maintenanceForm = this.fb.group({
      lastMaintenanceDate: ['', Validators.required],
      nextMaintenanceDate: [''],
      createdDate: [''],
      maintenanceDate: ['', Validators.required],
      maintainedBy: ['', Validators.required],
      approvedBy: ['', Validators.required],
      notes: ['', Validators.required],
      cost: ['', [Validators.required, Validators.min(0)]],
      status: ['', Validators.required],
    });
    this.currentUser = localStorage.getItem('currentUser');
    const currentUseroBJ = JSON.parse(this.currentUser);
    this.companySessionStorage = currentUseroBJ.company;
    this.branchSessionStorage = currentUseroBJ.branch;
    this.addProfileImage = "Upload";
    this.dialogVisibility = false;
    this.index = 0;
    this.company = new ICompany();
    this.branch = AuthService.getLoggedInCurrentBranch();
    this.invoiceData = this.branch.invoiceData;
    this.date = new Date();

    this.statusOptions = [
      { label: 'Pending', value: 'Pending' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Scheduled', value: 'Scheduled' }
    ];

    // Load categories when the component initializes
    this.loadCategories();
    this.getAssetById();
    this.getCompany();
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){

      this.appServiceManager.get('companies/current').subscribe((res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }

    }


  // Method to load categories
  loadCategories(): void {
    // Temporary static list of gym categories
    this.categories = [
      { label: "Cardio Equipment", value: 'Cardio Equipment' },
      { label: "Strength Equipment", value: 'Strength Equipment' },
      { label: "Flexibility Equipment", value: 'Flexibility Equipment' },
      { label: "Accessories", value: 'Accessories' },
    ];
  }

  getAssetById() {
    this.loading = true;
    this.appServiceManager.get("assets/" + this.assetID).subscribe(
      (res: any) => {
        if (res) {
          this.reports = res;
          this.asset = this.convertDates(res);
          this.maintenanceLogs = { ...this.asset.maintenanceLogs };
          this.setMaintenanceValues();
          this.loading = false;
        } else {
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }

  setMaintenanceValues() {
    const nextDate = new Date();
    nextDate.setDate(nextDate.getDate() + 30);
    const lastLog = this.asset.maintenanceLogs.length > 0
    ? this.asset.maintenanceLogs[this.asset.maintenanceLogs.length - 1]
    : null;
    this.maintenanceLogs.lastMaintenanceDate = lastLog?.lastMaintenanceDate ?? this.asset.purchaseDate;
    this.maintenanceLogs.nextMaintenanceDate = lastLog?.nextMaintenanceDate ?? nextDate;
    this.maintenanceLogs.maintainedBy = lastLog?.maintainedBy || '';
    this.maintenanceLogs.approvedBy = lastLog?.approvedBy || '';
    this.maintenanceLogs.notes = lastLog?.notes || '';
    this.maintenanceLogs.cost = lastLog?.cost ?? null;
    this.maintenanceLogs.status = this.getStatus(lastLog?.nextMaintenanceDate);
}

convertDates(obj: any): any {
  if (obj && typeof obj === 'object') {
    for (const key of Object.keys(obj)) {
      const value = obj[key];

      // Check if the value is a string and matches an explicit date format
      if (typeof value === 'string' && this.isDateString(value)) {
        obj[key] = new Date(value);
      } else if (typeof value === 'object' && value !== null) {
        this.convertDates(value); // Recursive for nested objects
      }
    }
  }
  return obj;
}

// Helper function to validate date strings explicitly
isDateString(value: string): boolean {
  // Adjust the regex for your accepted date formats (e.g., YYYY-MM-DD or MM/DD/YYYY)
  const dateRegex = /^\d{4}-\d{2}-\d{2}(T.*)?$/; // Matches ISO-like date strings
  return dateRegex.test(value);
}


openCompleteDialog(log): void {
  this.selectedLogId = log;
  this.maintenanceLogs.description = '';
  this.maintenanceLogs.cost = null;
  this.displayCompleteDialog = true;
}
openMaintenanceDialog() {
      this.displayMaintenaceDialog = true;
}

closeMaintenanceDialog() {
  this.displayMaintenaceDialog = false;
}

async markAsComplete(): Promise<void> {
  if (!this.selectedLogId) return;

  try {
    // Construct the update payload with the completed status, current date, and other fields
    const updatedLog = {
      status: 'Completed',
      lastMaintenanceDate: new Date(), // Use the current date
      description: this.maintenanceLogs.description,
      cost: this.maintenanceLogs.cost,
      nextMaintenanceDate: this.maintenanceLogs.nextMaintenanceDate,
      id:this.asset._id
    };

    // Update the specific maintenance log
    const res = await this.appServiceManager.put(`assets/updateStatus/${this.selectedLogId}`, updatedLog).toPromise();

    // Display success message if the API call succeeds
    if (res) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Maintenance status marked as completed.',
      });
      this.displayCompleteDialog = false; // Close dialog after success
      this.getAssetById();
    }
  } catch (error) {
    // Display error message if the API call fails
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to update maintenance status.',
    });
    console.error('Error updating maintenance status', error);
  }
}


getStatus(expectedDate: Date): string {
  const currentDate = new Date();

  // Compare dates by converting both to just the date (ignoring time)
  if (new Date(expectedDate).setHours(0, 0, 0, 0) > currentDate.setHours(0, 0, 0, 0)) {
      return "Scheduled";
  } else {
      return "Pending";
  }
}

validateAssetUpdate(form: any) {
  if (form.controls['name'].invalid) {
      const nameInput = document.getElementById('name');
      nameInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
      });
  }
  if (form.controls['category'].invalid) {
      const nameInput = document.getElementById('category');
      nameInput.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
      });
  }
  if (form.valid) {
     this.update();
  }
  else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
          const control = form.controls[controlName];
          control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
  }
}


  // Method to handle form submission
  async update(): Promise<void> {
      if (!this.asset.branch) {
        this.asset.branch = this.branchSessionStorage;
      }
      if (this.asset.company) {
        this.asset.company = this.companySessionStorage;
      }
      this.confirmationService.confirm({
        message: "Are you sure you want to update member?",
        accept: async () => {

          try {
            // Await the result of the asset creation API call

            const res = await this.appServiceManager.put("assets/" + this.asset._id, this.asset).toPromise();

            // Display success message for asset creation
            if (res) {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Asset successfully Updated.',
              });
            }
            // Check if the asset was created successfully and has an _id
            if (res.asset._id && this.uploadProfile) {
              // Prepare and upload the image only after asset creation
              const file = AppUtils.base64ToFile(
                this.uploadProfile,
                `${this.asset.name}.png:${this.companySessionStorage}:${this.branchSessionStorage}`
              );

              // Await the result of the upload function
              await this.uploadAssetImage(file, res.asset._id, true);
            }

          } catch (error) {
            // Handle errors for asset creation
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to add asset.',
            });
          }
        },
      });
    }

  async updateMaintenance(form: any): Promise<void> {
    if (form.valid) {
      if (!this.asset.branch) {
        this.asset.branch = this.branchSessionStorage;
      }
      if (this.asset.company) {
        this.asset.company = this.companySessionStorage;
      }
     form.value.createdDate = new Date();
     form.value.status = this.getStatus(form.value.nextMaintenanceDate);
      this.confirmationService.confirm({
        message: "Are you sure you want to update member?",
        accept: async () => {

          try {
            // Await the result of the asset creation API call

            const res = await this.appServiceManager.put(`assets/maintenance/${this.asset._id}`, form.value).toPromise();

            // Display success message for asset creation
            if (res) {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Asset successfully Updated.',
              });
              this.closeMaintenanceDialog();
              this.getAssetById();
            }

          } catch (error) {
            // Handle errors for asset creation
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to add asset.',
            });
          }
        },
      });
    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
      this.messageService.clear();
      this.messageService.add({
        severity: "error",
        summary: "Error Message",
        detail: "Please fill the member details.",
      });
    }
  }


  handleChange(e) {
    if (e.index === 2) {
      this.MaintenanceTabActive = true;
    }
  }
  // Method to reset the form after successful submission
  resetForm(): void {
    this.assetForm.reset();
  }

  clearProfile($event: any) {
    this.asset.profile = "assets/layout/images/2.png";
  }

  captureImageDialogShow(type: any) {
    this.addProfileImage = type; // Upload | Cam
    this.dialogVisibility = true;
  }
  hideAddProfileImage() {
    this.dialogVisibility = false;
  }
  handleImagefromNewProfile(webcamImage: string) {
    if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.asset.profile = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
    }
  }
  removeProfileImage() {
    this.uploadProfile = '';
    this.asset.profile = '';
  }

  uploadAssetImage(file: any, assetId: string | Blob, isAddMode = false) {
    let formData: FormData = new FormData();
    if (file) {

      formData.append("assetImage", file, file.name);
      formData.append("isThumb", "true");
      formData.append("assetId", assetId);
      formData.append("company", this.companySessionStorage);
      formData.append("branch", this.branchSessionStorage);
      formData.append("isAddMode", isAddMode.toString());

      this.appServiceManager.post("assets/upload", formData)
        .subscribe(
          (res: any) => {
          },
          (error: any) => {
            this.messageService.clear();
            this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
          }
        );
    }
  }
  printAllInvoice(): void {
    let printContents, popupWin;
    let currentDate = new Date();
    this.branch.name = "Sales Report - " + this.branch.name + " - " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
    printContents = document.getElementById('allInvoice').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
    <head>
    <title>${this.branch.name}</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: bottom;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
    </head>
    <body>${printContents}</body>
    </html>
    `
    );
  }
  getSummaryHtml() {
    let printContents;
    printContents = document.getElementById('allInvoice').innerHTML;

    let htmlToPdf = `<html>
    <body>${printContents}</body>
    </html>`

    return htmlToPdf;
  }
//   printAllInvoice(): void {
//     let printContents, popupWin;
//     let currentDate = new Date();
//     this.branch.name = this.branch.name + " " + currentDate.getDate() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getFullYear();
//     printContents = document.getElementById("allInvoice").innerHTML;
//     popupWin = window.open(
//         "",
//         "_blank",
//         "top=0,left=0,height=100%,width=auto"
//     );
//     popupWin.document.open();
//     popupWin.document.write(`
// <html>
// <head>
//     <title>${this.branch.name}</title>
//     <style>
//         .invoice-box {
//             max-width: 800px;
//             margin: auto;
//             padding: 30px;
//             border: 1px solid #eee;
//             box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
//             font-size: 16px;
//             line-height: 24px;
//             font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
//             color: #555;
//         }

//         .invoice-box table {
//             width: 100%;
//             line-height: inherit;
//             text-align: left;
//         }

//         .invoice-box table td {
//             padding: 5px;
//             vertical-align: top;
//         }

//         .invoice-box table tr td:nth-child(n + 2) {
//             text-align: right;
//         }

//         .invoice-box table tr.top table td {
//             padding-bottom: 20px;
//         }

//         .invoice-box table tr.top table td.title {
//             font-size: 45px;
//             line-height: 45px;
//             color: #333;
//         }

//         .invoice-box table tr.information table td {
//             padding-bottom: 40px;
//         }

//         .invoice-box table tr.heading td {
//             background: #eee;
//             border-bottom: 1px solid #ddd;
//             font-weight: bold;
//         }

//         .invoice-box table tr.details td {
//             padding-bottom: 20px;
//         }

//         .invoice-box table tr.item td {
//             border-bottom: 1px solid #eee;
//         }
//         .invoice-box table tr.item.last td {
//             border-bottom: none;
//         }
//         .invoice-box table tr.item input {
//             padding-left: 5px;
//         }
//         .invoice-box table tr.item td:first-child input {
//             margin-left: -5px;
//             width: 100%;
//         }
//         .invoice-box table tr.total td:nth-child(2) {
//             border-top: 2px solid #eee;
//             font-weight: bold;
//         }
//         .invoice-box input[type="number"] {
//             width: 60px;
//         }
//         @media only screen and (max-width: 600px) {
//             .invoice-box table tr.top table td {
//                 width: 100%;
//                 display: block;
//                 text-align: center;
//             }

//             .invoice-box table tr.information table td {
//                 width: 100%;
//                 display: block;
//                 text-align: center;
//             }
//         }
//         .rtl {
//             direction: rtl;
//             font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
//                 sans-serif;
//         }
//         .rtl table {
//             text-align: right;
//         }
//         .rtl table tr td:nth-child(2) {
//             text-align: left;
//         }
//     </style>
// </head>
// <body>${printContents}</body>
// </html>
// `);
// }

}
